// form
import { Controller } from 'react-hook-form';
// @mui
import { FormControlLabel, FormHelperText, Radio, RadioGroup } from '@mui/material';

// ----------------------------------------------------------------------

export default function RHFRadioGroup({ name, control, options, getOptionLabel, ...other }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <RadioGroup {...field} row {...other}>
            {options.map((option, index) => (
              <FormControlLabel
                key={option}
                value={option}
                control={<Radio />}
                label={getOptionLabel?.length ? getOptionLabel[index] : option}
              />
            ))}
          </RadioGroup>

          {!!error && (
            <FormHelperText error sx={{ px: 2 }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
